import { IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { MdDeleteForever, MdGroups } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Encabezado } from '../../../Components/Encabezado/Encabezado';

import Select from 'react-select';
import Loading from '../../../Components/Modals/Loading/Loader';

import {
  fetchCambiarSuccess,
  fetchDeleteCapacitacionArea,
  fetchEmpleadosDelete,
  fetchEmpleadosUpdate,
  fetchEstudiosGrados,
  fetchPeriodoEmpleadosArea,
  fetchPeriodos,
  selectEstudiosGrados,
  selectIsLoading,
  selectIsSuccess,
  selectMessage,
  selectPeriodoEmpleadoArea,
  selectPeriodos,
} from '../../../redux/Capacitaciones/CapacitacionesSlice';

import { fetchEmpleados, selectAllEmpleados } from '../../../redux/Empleados/EmpleadosSlice';

import { AgregarCapacitacionesEmpleadosModal } from '../../../Components/Capacitaciones/Modal/AgregarCapacitacionesEmpleadosModal';
import { VerEmpleadosCapacitacionModal } from '../../../Components/Capacitaciones/Modal/VerEmpleadosCapacitacionModal';
import { selectUserData } from '../../../redux/Login/LoginSlice';

import { colors } from '../../../utils/colors';

import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { IoAddCircle } from 'react-icons/io5';
import swal from 'sweetalert';

export const CapacitacionesSupervisor = () => {
  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-NAVIGATE
  const navigate = useNavigate();

  // ? HOOK-SELECTOR
  const usuario = useSelector(selectUserData);
  const empleadosCapacitaciones = useSelector(selectPeriodoEmpleadoArea);
  const periodos = useSelector(selectPeriodos);
  const estudiosGrados = useSelector(selectEstudiosGrados);
  const empleadosList = useSelector(selectAllEmpleados);
  const isLoading = useSelector(selectIsLoading);
  const isSuccess = useSelector(selectIsSuccess);
  const message = useSelector(selectMessage);

  // ? HOOK-STATE
  const [periodo, setPeriodo] = useState({});
  const [openVerEmpleados, setOpenVerEmpleados] = useState({ open: false, capacitacion: {} });
  const [openEditarEmpleado, setOpenEditarEmpleado] = useState({
    open: false,
    edit: true,
    empleado: {},
  });

  // * VALIDACIONES DEL HOOK-FORM EMPLEADOS.
  const formSchemaEmpleados = Yup.object().shape({
    empleado: Yup.object().shape({
      id: Yup.number(),
      empleadoId: Yup.number().nonNullable().notOneOf([0], 'El campo es requerido'),
      nombreGradoAlcanzado: Yup.string().trim().required('El campo es requerido'),
      gradoAlcanzado: Yup.number().nonNullable().notOneOf([0], 'El campo es requerido'),
    }),
  });

  // ? HOOK-FORM
  const formEditarEmpleado = useForm({
    mode: 'onChange',
    shouldUnregister: false,
    resolver: yupResolver(formSchemaEmpleados, { abortEarly: true, validateAllFieldCriteria: false }),
    defaultValues: {
      empleado: {
        id: 0,
        empleadoId: 0,
        nombreGradoAlcanzado: '',
        gradoAlcanzado: 0,
      },
    },
  });

  // * REFRESCAR LISTA
  const refreshList = () => {
    const filtro = {
      areaId: usuario?.AreaOrganizacionalId,
      periodoId: periodo.id,
    };

    dispatch(fetchPeriodoEmpleadosArea(filtro));
  };

  // ? HOOK-EFFECT
  useEffect(() => {
    if (Object.keys(usuario).length > 0 && periodo?.id > 0) {
      refreshList();
    }
  }, [usuario, periodo]);

  useEffect(() => {
    dispatch(fetchPeriodos());
    dispatch(fetchEstudiosGrados());
  }, []);

  useEffect(() => {
    if (periodos.length > 0) {
      setPeriodo(periodos.reverse()[0]);
    }
  }, [periodos]);

  useEffect(() => {
    const dataSolicitar = {
      skipRow: 0,
      rowsPerPage: 0,
      areaOrganizacionalId: usuario?.AreaOrganizacionalId,
      empleado: '',
      estado: 1,
    };

    dispatch(fetchEmpleados(dataSolicitar));
  }, [usuario]);

  useEffect(() => {
    if (Object.keys(openEditarEmpleado.empleado).length > 0) {
      // * DESESTRUCTURACION DE DATOS.
      const { capacitacionEmpleadoId, id: empleadoId, gradoAlcanzado, nombreGradoAlcanzado } = openEditarEmpleado?.empleado || {};

      formEditarEmpleado.setValue('empleado', {
        id: capacitacionEmpleadoId,
        empleadoId,
        gradoAlcanzado: gradoAlcanzado?.id,
        nombreGradoAlcanzado,
      });
    }
  }, [openEditarEmpleado]);

  useEffect(() => {
    if (isSuccess === 'success' && message) {
      swal('Exitoso!', message, 'success');
      formEditarEmpleado.reset();

      // * LIMPIAR STATE.
      setOpenEditarEmpleado({
        open: false,
        edit: true,
        empleado: {},
      });

      dispatch(fetchCambiarSuccess());
      dispatch(fetchPeriodos());

      // * REFRESCAR LISTA
      refreshList();
    } else if (isSuccess === 'error') {
      swal('Error', 'Por favor, comunicarse con el departamento de Desarrollo e Implentación de Sistemas.', 'error');
    }
  }, [isSuccess]);

  // ? HOOK-EFFECT PARA ACTUALIZAR LA CAPACITACION ABIERTA EN EL MODAL EN CASO DE REALIZAR UN CAMBIO.
  useEffect(() => {
    if (openVerEmpleados.open) {
      setOpenVerEmpleados({ ...openVerEmpleados, capacitacion: empleadosCapacitaciones.find((x) => x.id === openVerEmpleados.capacitacion.id) });
    }
  }, [empleadosCapacitaciones, isSuccess]);

  // * FUNCIONES
  const onUpdateEmpleado = ({ empleado }) => {
    dispatch(
      fetchEmpleadosUpdate({
        id: empleado.id,
        gradoAlcanzadoId: empleado.gradoAlcanzado,
        nombreGradoAlcanzado: empleado.nombreGradoAlcanzado,
      })
    );
  };

  const deleteEmpleado = (empleado) => {
    swal({
      title: `Esta seguro de eliminar a ${empleado.nombre} de la capacitación?`,
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((answer) => {
      if (answer) {
        dispatch(fetchEmpleadosDelete(empleado.capacitacionEmpleadoId));
      }
    });
  };

  const deleteCapacitacion = (capacitacion) => {
    swal({
      title: `Esta seguro de eliminar la capacitación ${capacitacion?.descripcion}?`,
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((answer) => {
      if (answer) {
        dispatch(fetchDeleteCapacitacionArea(capacitacion.empleados.map((x) => x.capacitacionEmpleadoId)));
      }
    });
  };

  return (
    <Encabezado title="Capacitaciones">
      <div className="border m-1 p-2 d-flex justify-content-between">
        <div className="col-8">
          <div className="form-group">
            <Typography fontSize="12px" fontWeight="bold">
              Período
            </Typography>
            <Select
              id="select-empleado"
              classNamePrefix="select"
              isSearchable={true}
              placeholder="Seleccionar Periodo"
              options={periodos}
              getOptionLabel={(option) => option.ano}
              getOptionValue={(option) => option.id}
              onChange={(e) => setPeriodo(e.id)}
              value={periodos.find((x) => x.id === periodo.id)}
            />
          </div>
        </div>
        <div className="col-4 d-flex justify-content-end">
          <button
            hidden={!periodo?.estado || periodo.validacionCierreRegistroCapacitaciones}
            className="btn btn-primary-mem"
            onClick={() => navigate('/capacitaciones/empleados/agregar')}
          >
            Agregar <IoAddCircle style={{ marginBottom: 4 }} fontSize="22" />
          </button>
        </div>
      </div>

      <Stack>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Capacitación</b>
                </TableCell>
                <TableCell>
                  <b>Tipo</b>
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {empleadosCapacitaciones.length > 0 ? (
                empleadosCapacitaciones.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.descripcion}</TableCell>
                    <TableCell>{item.tipo.descripcion}</TableCell>
                    <TableCell align="right">
                      <IconButton
                        hidden={!periodo?.estado || periodo.validacionCierreRegistroCapacitaciones}
                        onClick={() => setOpenVerEmpleados({ open: true, capacitacion: item })}
                        sx={{ color: colors.azulMem }}
                      >
                        <MdGroups fontSize={24} />
                      </IconButton>
                      <IconButton
                        hidden={!periodo?.estado || periodo.validacionCierreRegistroCapacitaciones}
                        onClick={() => deleteCapacitacion(item)}
                      >
                        <MdDeleteForever color="red" fontSize={22} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableCell colSpan={3}>No hay registros.</TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>

      <VerEmpleadosCapacitacionModal
        open={openVerEmpleados}
        setOpenEditarEmpleado={setOpenEditarEmpleado}
        setOpen={setOpenVerEmpleados}
        deleteEmpleado={deleteEmpleado}
      />

      <FormProvider {...formEditarEmpleado}>
        <AgregarCapacitacionesEmpleadosModal
          onSaveEmpleado={onUpdateEmpleado}
          empleadosListState={empleadosList}
          estudiosGradosState={estudiosGrados}
          open={openEditarEmpleado}
          setOpen={setOpenEditarEmpleado}
        />
      </FormProvider>

      <Loading open={isLoading} />
    </Encabezado>
  );
};
